/**
 * MasterWorkflowPage - Master workflow orchestration dashboard
 *
 * Surfaces the MasterWorkflowDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides HCBS service delivery orchestration with MN DHS program integration.
 *
 * Route: /admin/master-workflow
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconSitemap } from '@tabler/icons-react';

import { MasterWorkflowDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';
import { useSearchParams } from 'react-router-dom';

export function MasterWorkflowDashboardPage() {
  const { tenant } = useAuth();
  const [searchParams] = useSearchParams();
  const masterInstanceId = searchParams.get('instanceId') ?? 'demo';

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="violet">
            <IconSitemap size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Master Workflow Dashboard</Title>
            <Text size="sm" c="dimmed">
              HCBS service delivery orchestration and program management
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <MasterWorkflowDashboard masterInstanceId={masterInstanceId} />
    </Container>
  );
}

export default MasterWorkflowDashboardPage;
